export const WAITING = 'waiting';
export const ERROR = 'ERROR';
export const NOTIFICATION = 'NOTIFICATION';

